import { ProductIntroductionLine } from 'Components/lines/product-introduction-line/ProductIntroductionLine';
export default ProductIntroductionLine;
